import { TableCell, TableRow } from "@mui/material";
import { HeadquarterType } from "../../../../domain/models/headquarter-wise-sales/headquarter-wise-sales-type";
import { HeadquarterWiseSalesStore } from "../../../../store/main/HeadquarterWiseSalesStore";
import NoPrimarySalesModal from "./Modals/NoPrimarySalesModal";
import { useState } from "react";

type Props = {
  customer: HeadquarterType;
};

type CustomerDataType = {
  Headquarters: string;
  Total_Customers: number;
  Visits: number;
  Total_Productive_Orders: number;
  Total_Amount: number;
  Target: number;
  Secondary_Updated: number;
};

const HeadquarterWiseDetail: React.FC<Props> = ({ customer }) => {
  const { HeadquarterWiseSalesData } = HeadquarterWiseSalesStore();
  const [open, setOpen] = useState<boolean>(false);
  const CustomerData: CustomerDataType = {
    Headquarters: customer.name,
    Total_Customers:
      HeadquarterWiseSalesData.customers.find(
        (c) => c.hq_headquarter_id === customer.id
      )?.total_customers || 0,
    Visits: 0,
    Total_Productive_Orders: 0,
    Total_Amount: 0,
    Target: 0,
    Secondary_Updated: 0,
  };
  HeadquarterWiseSalesData.visits.forEach((visit) => {
    if (visit.hq_headquarter_id === customer.id) {
      CustomerData.Visits += visit.visit_count;
    }
  });
  HeadquarterWiseSalesData.orders.forEach((order) => {
    if (order.hq_headquarter_id === customer.id) {
      CustomerData.Total_Productive_Orders += order.order_count;
    }
  });
  HeadquarterWiseSalesData.primary_sales_and_targets.forEach((sales) => {
    if (sales.hq_headquarter_id === customer.id) {
      CustomerData.Total_Amount += parseInt(sales.total_net_amount);
      CustomerData.Target += parseInt(sales.total_target);
    }
  });

  const openNoPrimary = () => {
    setOpen(true);
  };
  const closeNoPrimary = () => {
    setOpen(false);
  };


  return (
    <>
      <TableRow>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Headquarters}
        </TableCell>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Total_Customers}
        </TableCell>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Visits}
        </TableCell>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Total_Productive_Orders}
        </TableCell>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Total_Amount}
        </TableCell>
        <TableCell sx={{ border: "1px solid #dddddd" }}>
          {CustomerData.Target}
        </TableCell>
        <TableCell
          sx={{ border: "1px solid #dddddd", cursor: "pointer" }}
          onClick={openNoPrimary}
        >
          {CustomerData.Secondary_Updated}
        </TableCell>
      </TableRow>
      {open && <NoPrimarySalesModal open={open} handleClose={closeNoPrimary} />}
    </>
  );
};

export default HeadquarterWiseDetail;
